/* eslint-disable no-unused-vars */
import create from "zustand";
import "./XRPage.css";
import { React } from "react";
import Frontend from "./Frontend";
import ARControllerUI from "../components/ARControllerUI";

const store = (set) => ({
  showARControllerUI: true,
  setshowARContollerUI: (showARControllerUI) => set({ showARControllerUI }),
});

const useXRPageStore = create(store);
export const XRPageState = useXRPageStore.getState;

const XRPage = () => {
  const showARControllerUI = useXRPageStore((s) => s.showARControllerUI);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div className="XRPage">
      {showARControllerUI && <ARControllerUI />}
      <Frontend />
    </div>
  );
};

export default XRPage;
